import { combineReducers } from "redux";

// Front
import Layout from "./layout/reducer";

// Calendar
import calendar from "./calendar/reducer";

// Authentication
import forgetPassword from "./auth/forgetpwd/reducer";
import login from "./auth/login/reducer";
import profile from "./auth/profile/reducer";
import account from "./auth/register/reducer";

// Classroom
import classroom from "./classroom/reducer";

// Search term reducer
import searchTermReducer from "./searchTermReducer";  // Assuming you've placed this in a separate file (e.g., searchTermReducer.js)

const rootReducer = combineReducers({
  // public
  Layout,
  calendar,
  forgetPassword,
  login,
  profile,
  account,
  classroom,
  searchTerm: searchTermReducer,  // Include searchTerm reducer here
});

export default rootReducer;
